import React from 'react';
import { Redirect, useLocation } from 'react-router';
import { getUserAuth } from 'data/storage';
import cooperationSDK from 'lib/cooperationSdk';
import APP_ROUTE from 'constant/route';

const AuthUser: React.FC = ({ children }) => {
  const location = useLocation();
  if (cooperationSDK.isCoEnv && !getUserAuth()) {
    return <Redirect to={APP_ROUTE.NONE + location.search} />;
  }

  return <>{children}</>;
};

export default AuthUser;
